// "gre": null,
// "gre_verbal": null,
// "gre_quantitative": null,

export const GRE_TESTING_TYPES = ['gre'];
const isGreTestingType = (type: string) => GRE_TESTING_TYPES.includes(type);

interface StandardGreItem {
  type: string;
  total: number;
  verbal: number;
  quantitative: number;
}

export default class GreConverter {
  static is = isGreTestingType;
  static isValid = (item: StandardGreItem) => {
    return item.total > 0 || item.verbal > 0 || item.quantitative > 0;
  };

  static toArray(resume: Record<string, any>) {
    return GRE_TESTING_TYPES.map((type) => {
      const typeObj = resume[`${type}_test_score`];
      if (typeObj) return { type, ...typeObj };
      const total = resume[`${type}`] || null;
      const verbal = resume[`${type}_verbal`] || null;
      const quantitative = resume[`${type}_quantitative`] || null;
      return { type, total, verbal, quantitative };
    });
  }

  static toValidArray(resume: Record<string, any>) {
    const items = this.toArray(resume);
    return items.filter(GreConverter.isValid);
  }

  static toObject(items: StandardGreItem[]) {
    const resume = {};
    items.forEach((item) => {
      const { type, total, verbal, quantitative } = item;
      resume[`${type}`] = total;
      resume[`${type}_verbal`] = verbal;
      resume[`${type}_quantitative`] = quantitative;

      resume[`${type}_test_score`] = {
        total,
        verbal,
        quantitative,
      };
    });

    return resume;
  }

  static defaults() {
    return {
      gre: null,
      gre_verbal: null,
      gre_quantitative: null,

      // v2 version
      gre_test_score: {
        total: null,
        verbal: null,
        quantitative: null,
      },
    };
  }
}
